import Breadcrumb from "../components/Breadcrumb";
import WorkFlowAssignLayer from "../components/WorkFlowAssignLayer";

const WorkFlowAssignpage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Workflows Assign" />

      < WorkFlowAssignLayer/>
    </>
  );
};

export default WorkFlowAssignpage;
